/** Secciones de una letra: bloques separados por línea en blanco; "[Coro]" al inicio nombra la sección. */
export function sections(lyrics: string): { name: string | null; lines: string[] }[] {
  return lyrics
    .replace(/\r\n/g, '\n')
    .split(/\n\s*\n/)
    .map((block) => block.split('\n').map((l) => l.trimEnd()))
    .filter((lines) => lines.some((l) => l.trim()))
    .map((lines) => {
      const m = /^\s*\[(.+)\]\s*$/.exec(lines[0] ?? '');
      return m ? { name: m[1]!.trim(), lines: lines.slice(1) } : { name: null, lines };
    });
}

/** Letra lista para Presentación: una diapositiva por sección, sin los nombres entre corchetes. */
export const toSlides = (lyrics: string) =>
  sections(lyrics)
    .map((s) => s.lines.join('\n').trim())
    .filter(Boolean)
    .join('\n\n');
